import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Orthodontics = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.071 21.01h-1.88v-.694c0-5.544-4.754-10.396-10.1-10.396-3.961 0-7.526 2.376-9.11 5.842-1.584-3.466-5.149-5.842-9.11-5.842-5.346 0-10.099 4.852-10.099 10.397v.693H.892c-1.189 0-1.189 1.782 0 1.88h1.88v6.14c0 2.772 2.278 5.05 4.951 5.05h10.1c1.683 0 3.168-.892 4.158-2.179a5.015 5.015 0 0 0 4.159 2.179h10.1c2.772 0 4.95-2.278 4.95-5.05v-6.14h1.881c1.189-.098 1.288-1.88 0-1.88Zm-30.2-9.308c4.655 0 8.22 3.96 8.22 8.416v.793h-4.358v-.99a1.88 1.88 0 0 0-1.88-1.882h-4.06A1.88 1.88 0 0 0 8.91 19.92v1.09H4.654c-.495-4.852 3.168-9.308 8.218-9.308Zm8.12 17.328c0 1.683-1.386 3.07-3.168 3.07h-10.1c-1.782 0-3.168-1.387-3.168-3.17v-6.139h4.257v1.189c0 .99.792 1.881 1.882 1.881h4.06c.99 0 1.88-.89 1.88-1.881v-1.188h4.357c.1 1.089 0 6.139 0 6.238Zm18.318-.1c0 1.783-1.386 3.17-3.169 3.17h-10c-1.782 0-3.169-1.387-3.169-3.07v-6.14h4.357v1.189c0 .99.792 1.881 1.881 1.881h4.06c.99 0 1.881-.89 1.881-1.881v-1.188h4.258v1.98c-.1 1.683 0 3.862-.1 4.06Zm0-7.92H35.05v-1.09a1.88 1.88 0 0 0-1.881-1.88h-4.06a1.88 1.88 0 0 0-1.881 1.88v1.09h-4.258v-.793c0-4.554 3.565-8.416 8.219-8.416 4.95-.099 8.614 4.357 8.119 9.209Z"
  }));
});
Orthodontics.displayName = 'Orthodontics';
Orthodontics.defaultProps = {
  'aria-label': 'Orthodontics'
};
export default Orthodontics;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Orthodontics.js
// module id = 3681
// module chunks = 11